import script from "./CompareHtml.vue?vue&type=script&setup=true&lang=js"
export * from "./CompareHtml.vue?vue&type=script&setup=true&lang=js"

import "./CompareHtml.vue?vue&type=style&index=0&id=4579c8d8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4579c8d8"]])

export default __exports__